import { forwardRef } from 'react'
import { InputProps } from '@/types'
import { cn } from '@/lib/utils'

interface ExtendedInputProps extends Omit<InputProps, 'onChange'> {
  onChange?: any
}

export const Input = forwardRef<HTMLInputElement, ExtendedInputProps>(
  ({ 
    className, 
    type = 'text', 
    placeholder, 
    value, 
    onChange, 
    error, 
    disabled, 
    required,
    ...props 
  }, ref) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        try {
          // Always pass the event object to react-hook-form
          // React Hook Form expects the event object, not just the value
          onChange(e)
        } catch (error) {
          // Silently handle error
        }
      }
    }

    return (
      <div className="space-y-1">
        <input
          ref={ref}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          disabled={disabled}
          required={required}
          className={cn(
            "w-full px-4 py-3 border-2 border-gray-300 rounded-lg text-base transition-colors",
            "focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20",
            "disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed",
            error && "border-error focus:border-error focus:ring-error/20",
            className
          )}
          {...props}
        />
        {error && (
          <p className="text-sm text-error">{error}</p>
        )}
      </div>
    )
  }
)

Input.displayName = "Input"
